import { CreateEditFormDrawer } from 'framework/ViewTypes/contentLayout';
import { createPositionProfileInitialFormValues } from '../constants';
import { usePositionProfilesUrl } from '../routing';
import type { PositionProfile, PositionProfileFormValues } from '../types';
import usePositionProfilesService from '../usePositionProfilesService';
import { getPositionProfileFormSections } from './positionProfileFormSections';

type PositionProfileFormDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
  profile?: PositionProfile;
  onSuccess?: (profile: PositionProfile) => void;
};

const PositionProfileFormDrawer = ({ isOpen, onClose, profile, onSuccess }: PositionProfileFormDrawerProps) => {
  const { create, update, getValidationSchema, getUpdateValidationSchema } = usePositionProfilesService();
  const { getSingleEntityUrl } = usePositionProfilesUrl();
  const isEdit = Boolean(profile);
  const isDefinitionDisabled = Boolean(profile?.nonRetiredLinkedPositionsCount);

  return (
    <CreateEditFormDrawer
      key={`${profile?.id ?? 'create'}-${isOpen}`}
      isOpen={isOpen}
      onClose={onClose}
      title={isEdit ? 'Edit position profile' : 'Create position profile'}
      width={864}
      initialData={profile ?? createPositionProfileInitialFormValues()}
      isCreateRequest={!isEdit}
      submitFormFunc={values =>
        profile ? update(profile.id, values as PositionProfileFormValues) : create(values as PositionProfileFormValues)
      }
      afterSubmit={
        profile
          ? {
              execute: updatedProfile => {
                onSuccess?.(updatedProfile);
                onClose();
              },
              message: 'Position profile updated successfully.',
            }
          : {
              redirect: createdProfile => getSingleEntityUrl(createdProfile.id),
              message: 'Position profile created successfully.',
            }
      }
      getValidationSchemaFunc={isEdit ? getUpdateValidationSchema : getValidationSchema}
      getSections={data =>
        getPositionProfileFormSections(
          (data.salaryRanges ?? []) as PositionProfileFormValues['salaryRanges'],
          isDefinitionDisabled,
        )
      }
    />
  );
};

export default PositionProfileFormDrawer;
